import { SetNewPasswordComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const SetNewPasswordAdmin = () => {
	return <SetNewPasswordComponent signInLink={APP_ROUTES.SIGN_IN_ADMIN} />;
};

export default SetNewPasswordAdmin;
